import { render, staticRenderFns } from "./LanguagesChange.vue?vue&type=template&id=6ae63040&scoped=true&"
import script from "./LanguagesChange.vue?vue&type=script&lang=js&"
export * from "./LanguagesChange.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesChange.vue?vue&type=style&index=0&id=6ae63040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae63040",
  null
  
)

export default component.exports